export * from './icon-registry-proxy.service';
export * from './icon.model';
